import * as React from 'react';

interface BentoPortionProps {
  name: string;
  local?: boolean;
}

export const BentoPortion: React.FunctionComponent<BentoPortionProps> = props => (props.children ? <>{props.children}</> : null);
BentoPortion.displayName = 'BentoPortion';
